import { render } from "./NotificationsView.vue?vue&type=template&id=5487928d&scoped=true"
import script from "./NotificationsView.vue?vue&type=script&lang=js"
export * from "./NotificationsView.vue?vue&type=script&lang=js"

import "./NotificationsView.vue?vue&type=style&index=0&id=5487928d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5487928d"]])

export default __exports__